import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import GenericShowcase from '../listings/GenericShowcaseListing/GenericShowcaseListingJsFile';


let store;


function GenericShowcaseApp() {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<GenericShowcase />
			</RouterProvider>
		</Provider>
	);
}

export function renderGenericShowcase(id, mg, auth, micrositeRender, showcaseCollection) {

	if (!store) {
		store = configureStore(router);
	}
	
	store.dispatch(Actions.initialiseSettings('GenericShowcaseAppId', mg, auth, micrositeRender, showcaseCollection));


	
	router.start(() => {
		ReactDOM.render(<GenericShowcaseApp />, document.getElementById(id));
	});
}
